import get from 'transmute/get';
export const getResolvedAttachments = get('resolvedAttachments');